<style type="text/css" media="screen">
.welcome-images{
  height: 200px;
}  
</style>

<template>
 <div class="text-center">
  <v-dialog
  v-model="$store.state.welcome_dialog"
  width="500"
  persistent
  >
  <v-card class="pa-5 text-center"> 
    <p class="text-right" style="">
      <v-icon color="#8F8F8F" small @click="$store.state.welcome_dialog=false">
        mdi-window-close
      </v-icon>
    </p>
    <v-stepper
    v-model="e1"
    class="elevation-0"
    >
    <template>
      <v-stepper-items  >
        <v-stepper-content
        v-for="n in steps"
        :key="`${n}-content`"
        :step="n"
        >
        <div v-if="welcome_data[n-1]">

          <img :src="welcome_data[n-1].image_url" alt="img" class="welcome-images px-3">

          <p class="sub-title-text mt-3">{{welcome_data[n-1].title}}</p>
          <p class="sub-title-text-dark fs-12">{{welcome_data[n-1].description}}</p>

        </div>
      </v-stepper-content>
    </v-stepper-items>
  </template>

</v-stepper>
<!-- steps -->
<div>
  <span v-for="n in steps" :key="n" class="mx-1 cursor-pointer" @click="nextStep(n-1)">
    <v-icon small :color="n==e1?'primary':'rgba(44, 62, 80, 0.19)'" >mdi-circle</v-icon>
  </span>
</div>

<div class="mt-5">
  <v-btn class="primary fs-13" width="135px" @click="nextStep(e1)" v-if="e1==steps">
    <b>{{$lang.GET_STARTED}} </b>
  </v-btn>
  <v-btn class="primary fs-13" width="135px" @click="nextStep(e1)" v-else>
    <b>{{$lang.NEXT}} </b>
  </v-btn>
<!--   <v-btn class="fs-13 ml-4" width="135px" @click="$store.state.welcome_dialog=false" >
    <b>{{$lang.SKIP}} </b>
  </v-btn> -->
</div>
</v-card > 
</v-dialog>
</div>
</template>


<script>
export default {
  data () {
    return {
      e1: 1,
      steps: 1,
      welcome_data:[],
    }
  },
  created(){
    this.welcomeData();
  },
  methods: {
   welcomeData(){
    const self=this
    let params={
    };
    const successHandler = (response) => {
      console.log(response)
      if (response.data.success){
        self.welcome_data=response.data.welcome_data
        self.steps=response.data.welcome_data.length
      }
    };
    const finallyHandler = () => {
      self.table_loading=false
    };
    self.request_GET( self,self.$urls.WELCOME_SCREEN,params,successHandler,null,null,finallyHandler)
  },

  nextStep (n) {
    if (n === this.steps) 
      this.$store.dispatch('setWelcomeDialog',false)
    else 
      this.e1 = n + 1
  },
},
}
</script>